import React from 'react';
import defaultStyle from '../error-tooltip/index.module.scss';
import cancelIcon from '../../../assets/cancel.svg';
import SuccessIcon from '../../../assets/successIcon.svg';

interface Props {
  successMessage?: string;
  setCloseTooltip: Function;
}


const SuccessTooltip = ({ successMessage, setCloseTooltip }: Props) => {

  const completeMessage = (
    <>
      Envíamos un código al <br />
      {successMessage}
    </>
  );

  const oncloseTooltip = () => {
    setCloseTooltip(true);
  };

  return (
    <div className={defaultStyle.container}>
      <div className={defaultStyle.details}>
        <img
          src={SuccessIcon}
          alt={'SuccessIcon'}
          style={{ width: '24px', height: '24px', padding: '22px 0 0 0' }}
        />
        <div style={{ paddingTop: '10px', textAlign: 'left' }}>{completeMessage}</div>
        <img
          src={cancelIcon}
          alt={'cancelIcon'}
          style={{
            width: '24px',
            height: '24px',
            padding: '22px 10px 0 10px',
            cursor: 'pointer'
          }}
          onClick={oncloseTooltip}
        />
      </div>
    </div>
  );
};

export default SuccessTooltip;
